import Homepage from './Homepage/Homepage';

const Dashboard = () => {
  return <Homepage />;
};

export default Dashboard;
